var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',{staticClass:"p"},[_vm._v(" Copyright © 2017～2022 版权所有 广东创世科技有限公司 "),_c('br'),_vm._v("All Rights Reserved 粤ICP备2021110769号-1 ")])])
}]

export { render, staticRenderFns }